import sprintsCarouselNutritionSrc from "#/features/sprints-landing/assets/images/sprints-carousel-nutrition.jpg"
import sprintsCarouselNutritionMobileSrc from "#/features/sprints-landing/assets/images/sprints-carousel-nutrition-mobile.jpg"
import sprintsCarouselMovementSrc from "#/features/sprints-landing/assets/images/sprints-carousel-movement.jpg"
import sprintsCarouselMovementMobileSrc from "#/features/sprints-landing/assets/images/sprints-carousel-movement-mobile.jpg"
import sprintsCarouselSleepSrc from "#/features/sprints-landing/assets/images/sprints-carousel-sleep.jpg"
import sprintsCarouselSleepMobileSrc from "#/features/sprints-landing/assets/images/sprints-carousel-sleep-mobile.jpg"
import sprintsCarouselStressSrc from "#/features/sprints-landing/assets/images/sprints-carousel-stress.jpg"
import sprintsCarouselStressMobileSrc from "#/features/sprints-landing/assets/images/sprints-carousel-stress-mobile.jpg"
import sprintsCarouselTelemedSrc from "#/features/sprints-landing/assets/images/sprints-carousel-telemed.jpg"
import sprintsCarouselTelemedMobileSrc from "#/features/sprints-landing/assets/images/sprints-carousel-telemed-mobile.jpg"
import { SPRINTS_MESSAGES } from "#/features/sprints-landing/en-only-text"

export type ContentFilters = {
  showGLP1Content: boolean
  showTelemedicineContent: boolean
}

export const sprintsCarouselSections = [
  {
    id: "nutrition",
    description: SPRINTS_MESSAGES.carousel.nutrition.description,
    image: sprintsCarouselNutritionSrc,
    imageMobile: sprintsCarouselNutritionMobileSrc,
    getShowContent: (_contentFilters: ContentFilters) => true
  },
  {
    id: "movement",
    description: SPRINTS_MESSAGES.carousel.movement.description,
    image: sprintsCarouselMovementSrc,
    imageMobile: sprintsCarouselMovementMobileSrc,
    getShowContent: (_contentFilters: ContentFilters) => true
  },
  {
    id: "sleep",
    description: SPRINTS_MESSAGES.carousel.sleep.description,
    image: sprintsCarouselSleepSrc,
    imageMobile: sprintsCarouselSleepMobileSrc,
    getShowContent: (_contentFilters: ContentFilters) => true
  },
  {
    id: "stress",
    description: SPRINTS_MESSAGES.carousel.stress.description,
    image: sprintsCarouselStressSrc,
    imageMobile: sprintsCarouselStressMobileSrc,
    getShowContent: (_contentFilters: ContentFilters) => true
  },
  {
    id: "telemedicine",
    description: SPRINTS_MESSAGES.carousel.telemedicine.description,
    image: sprintsCarouselTelemedSrc,
    imageMobile: sprintsCarouselTelemedMobileSrc,
    getShowContent: (contentFilters: ContentFilters) => contentFilters.showGLP1Content
  }
]
